/**
 * The selection bar's actions, in the spec's order (melody toolkit M6; spec §5.4, §11), and what each needs to be
 * available. In their own module so `selection-bar.tsx` exports only its component (react-refresh).
 */

export const selectionActions = [
  { action: 'repeat', label: 'Repeat' },
  { action: 'repeat-fit', label: 'Repeat, fit to chords' },
  { action: 'sequence-up', label: 'Sequence up' },
  { action: 'sequence-down', label: 'Sequence down' },
  { action: 'mirror', label: 'Mirror' },
  { action: 'shift-earlier', label: 'Shift earlier' },
  { action: 'shift-later', label: 'Shift later' },
] as const

export type SelectionAction = (typeof selectionActions)[number]['action']

export interface SelectionActionAvailability {
  isAvailable: boolean
  /** Shown once, describing the action: only the no-key reason has one (Brian's Q3) */
  reason?: string
}
